import React from 'react'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'

export const RegionsFilter = ({ regions, buildUrl }) => {
  return regions.map((name, i) => (
    <Link key={`category-${i}`} className="tag-outline" to={buildUrl(name)}>
      {name}
    </Link>
  ))
}

export const forCategory = (name) => `/categories/${kebabCase(name)}/`
export const forTag = (name) => `/tags/${kebabCase(name)}/`
